module.exports = __webpack_public_path__ + "images/icons/icon-https-bab68c6a.svg";